import { BaseWidgetRenderer } from './base-widget-renderer';
import { SignUpWidgetJsonData, WidgetRenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';

export class SignUpWidgetRenderer extends BaseWidgetRenderer<SignUpWidgetJsonData> {
    protected override get defaultData(): SignUpWidgetJsonData {
        return {
            id: '',
            type: 'signup',
            content: TranslateUtils.SIGN_UP_WIDGET.TEXT
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected renderContent(widgetJsonData: SignUpWidgetJsonData, options: WidgetRenderOptions): HTMLElement {
        const content = document.createElement('div');
        content.classList.add('element-content');

        const textElement = document.createElement('div');
        textElement.dataset['inlineInject'] = '';
        textElement.classList.add('ck-content');

        if (widgetJsonData.content) {
            textElement.innerHTML = widgetJsonData.content;
        }

        content.appendChild(textElement);
        return content;
    }
}
